import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import Button from './Button'
import Icon from './Icon'
import { H2, H5 } from './Typography'
import Img from 'gatsby-image'
import media from 'css-in-js-media'
import AnimatedSection from './AnimatedSection'
import { Variables } from '../styles/Variables'
import { StyledButton } from './ButtonStyled'
import LocalLink from './LocalLink'

export const QuickLinksSection = styled.section`
    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
        :last-child {
            ${media('<desktop')} {
                margin-top: 20px;
            }
        }
    }

    ${Row} {
        margin: 0;
    }

    ${H2} {
        margin-bottom: 40px;
        ${media('>=desktop')} {
            margin-bottom: 80px;
        }
    }
`

const LinkWrap = styled.div`
    position: relative;
    cursor: pointer;

    ${Icon} {
        width: 30px;
        height: 30px;
        ${media('<desktop')} {
            height: 20px;
            width: 20px;
            min-width: 20px;
            margin-top: 3px;
        }
        svg {
            width: 100%;
            height: 100%;

            path {
                stroke: ${Variables.color.cocoa};
            }
        }
    }

    ${H5} {
        text-align: left;
        white-space: normal;
        ${media('<desktop')} {
            padding-right: 16%;
        }
    }

    a:hover svg path {
        stroke: black;
    }
`

const LinksWrapper = styled.div`
    background-color: ${Variables.color.white};
    padding: 87px 170px 139px 170px;

    ${media('<desktop')} {
        padding: 37px 20px 20px 20px;
    }

    ${H2} {
        margin-bottom: 50px;
        font-size: 38px;
        line-height: 44px;
        font-family: ${Variables.font.title};
        ${media('<desktop')} {
            margin-bottom: 23px;
            font-size: 24px;
            line-height: 30px;
        }
    }
`

const ButtonWrap = styled.div`
    ${H5} {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 24px;
        line-height: 100%;
        color: ${Variables.color.pazola};
    }
    position: absolute;
    bottom: 30px;
    right: 30px;
    left: 30px;
    ${media('<desktop')} {
        bottom: 12px;
        right: 12px;
        left: 12px;
    }

    ${StyledButton} {
        background-color: ${Variables.color.white};
        padding: 18px 15px;
        max-width: 100%;
        min-width: 100%;
        height: 60px;
        text-transform: initial;
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 24px;
        line-height: 100%;
        color: ${Variables.color.pazola};
        letter-spacing: initial;
        &::before {
            display: none;
        }
        ${media('<desktop')} {
            font-size: 16px;
            line-height: 20px;
            height: 36px;
            padding: 8px 12px;
        }
    }
`

const LinkBackground = styled.div`
    img {
        vertical-align: top;
    }
`

const Quicklinks = ({ data }) => {
    const links = [
        {
            link: data.link1,
            name: data.name1,
            image: data.image1,
        },
        {
            link: data.link2,
            name: data.name2,
            image: data.image2,
        },
    ]
    return (
        <QuickLinksSection>
            <LinksWrapper>
                <AnimatedSection>
                    <H2 center>{data.title}</H2>
                    <Row>
                        {links.map((link, index) => {
                            return (
                                <Col key={index} md={6}>
                                    <LocalLink to={link?.link?.internalLink?.slug}>
                                        <LinkWrap>
                                            <LinkBackground>
                                                <Img fluid={link.image.fluid} alt="" />
                                            </LinkBackground>
                                            <ButtonWrap>
                                                <Button largewhite fluid textalign="left">
                                                    {link.name}
                                                </Button>
                                            </ButtonWrap>
                                        </LinkWrap>
                                    </LocalLink>
                                </Col>
                            )
                        })}
                    </Row>
                </AnimatedSection>
            </LinksWrapper>
        </QuickLinksSection>
    )
}

export default Quicklinks
